export const iconFontAwesomeShapesCalendar = (
	<i className="fa-solid fa-calendar"></i>
);
